import { NgModule } from '@angular/core';
import { FiltroClientesCerradosPipe } from '../filtro-clientes-chats-cerrados.pipe';
import { FiltroClientesPipe } from '../filtro-clientes.pipe';
import { AgentesReasigPipe } from './agentesReasig.pipe';
import { FiltroAgentesPipe } from './filtro-agentes.pipe';
import { FiltroOrigenPipe } from './filtro-origen.pipe';
import { FiltroRepChatPipe } from './filtro-rep-chat.pipe';
import { FiltroStatusPipe } from './filtro-status.pipe';
import { FiltroEquipoPipe } from './filtroEquipo.pipe';
import { SaltoLineaPipe } from './saltoLinea.pipe';
import { FiltroClientesSemaforoPipe } from '../filtro-clientes-semaforo.pipe';
import { FiltroResultadosPipe } from './filtro-resultados-chat.pipe';
import { FiltroCodigoPipe } from '../filtro-codigo.pipe';
import { NumeroSinCodPipe } from './numero-sin-cod.pipe';
import { ConverLeadsPipe } from './conver-leads.pipe';
import { RespuestasRapidasPipe } from '../respuestas-rapidas.pipe';
import { FiltroPlantillasPipe } from './filtro-plantillas.pipe';





@NgModule({
  declarations: [
    //FiltroPipe
    FiltroAgentesPipe,
    AgentesReasigPipe,
    FiltroEquipoPipe,
    FiltroRepChatPipe,
    FiltroStatusPipe,
    FiltroOrigenPipe,
    FiltroClientesPipe,
    FiltroClientesCerradosPipe,
    FiltroPlantillasPipe,
    SaltoLineaPipe,
    FiltroClientesSemaforoPipe,
    FiltroResultadosPipe,
    FiltroCodigoPipe,
    NumeroSinCodPipe,
    ConverLeadsPipe,
    RespuestasRapidasPipe
  ],
  exports: [
    FiltroAgentesPipe,
    AgentesReasigPipe,
    FiltroEquipoPipe,
    FiltroRepChatPipe,
    FiltroPlantillasPipe,
    FiltroStatusPipe,
    FiltroOrigenPipe,
    FiltroClientesPipe,
    FiltroClientesCerradosPipe,
    SaltoLineaPipe,
    FiltroClientesSemaforoPipe,
    FiltroResultadosPipe,
    FiltroCodigoPipe,
    NumeroSinCodPipe,
    ConverLeadsPipe,
    RespuestasRapidasPipe
  ]
})
export class PipesModule { }
